module.exports = __webpack_public_path__ + "static/img/team.0549027.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/channels/team.png
// module id = y4Rv
// module chunks = 1